import { api } from './api';

export const shipmentStatusService = {
  getAll: async () => {
const response = await api.get('/api/shipmentstatuses');
    return response.data;
  },
  
  getById: async (id: number) => {
const response = await api.get(`/api/shipmentstatuses/${id}`);
return response.data;
},  
  create: async (data: any) => {
    const response = await api.post('/api/shipmentstatuses', data);
    return response.data;
  },  
  update: async (id: number, data: any) => {
    const response = await api.put(`/api/shipmentstatuses/${id}`, data);
    return response.data;
  },  
  delete: async (id: number) => {
    const response = await api.delete(`/api/shipmentstatuses/${id}`);
    return response.data;
  },
};
